import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

const pains = [
  { num: '01', text: 'Missing BPM and key data across your library' },
  { num: '02', text: 'Corrupted ID3 tags from different download sources' },
  { num: '03', text: 'Hours of manual metadata fixing before every gig' },
  { num: '04', text: 'Rekordbox import/export losing cue points and tags' },
];

export default function Problem() {
  const ref = useRef(null);
  const v = useInView(ref, { once: true, margin: '-80px' });

  return (
    <section id="problem" data-testid="problem-section" ref={ref} style={{ padding: 'clamp(120px,14vw,200px) 0' }}>
      <div className="container">
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 80, alignItems: 'start' }} className="prob-grid">
          <motion.div initial={{ opacity: 0, y: 30 }} animate={v ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.8 }}>
            <span style={{ fontFamily: 'var(--mono)', fontSize: 11, fontWeight: 500, color: '#52525B', letterSpacing: '0.1em', textTransform: 'uppercase' }}>The Problem</span>
            <h2 data-testid="problem-title" style={{ fontFamily: 'var(--heading)', fontWeight: 800, fontSize: 'clamp(2rem, 4vw, 3rem)', lineHeight: 1.1, letterSpacing: '-0.03em', marginTop: 16, marginBottom: 20 }}>
              Your library is broken.<br /><span style={{ color: '#52525B' }}>Bonk fixes it.</span>
            </h2>
            <p style={{ color: '#71717A', fontSize: 15, lineHeight: 1.8, maxWidth: 400 }}>
              Every DJ knows the pain of messy metadata. You spend more time fixing tags than actually mixing. It doesn't have to be this way.
            </p>
          </motion.div>

          <div>
            {pains.map((p, i) => (
              <motion.div key={i} data-testid={`pain-point-${i}`} initial={{ opacity: 0, x: 20 }} animate={v ? { opacity: 1, x: 0 } : {}} transition={{ duration: 0.6, delay: 0.2 + i * 0.08 }}
                style={{ display: 'flex', alignItems: 'flex-start', gap: 16, padding: '20px 0', borderBottom: '1px solid rgba(255,255,255,0.04)' }}>
                <span style={{ fontFamily: 'var(--mono)', fontSize: 11, fontWeight: 500, color: '#3F3F46', flexShrink: 0, marginTop: 2 }}>{p.num}</span>
                <span style={{ color: '#A1A1AA', fontSize: 14, lineHeight: 1.6 }}>{p.text}</span>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
      <style>{`@media(max-width:768px){.prob-grid{grid-template-columns:1fr !important;gap:40px !important}}`}</style>
    </section>
  );
}
